import './MonitorUpsellCard.scss';

import classNames from 'classnames';
import { FeatureFlag } from '@sonar-software/sonar-core';
import Icon from '@ant-design/icons';
import monitorUpsellIcon1 from 'images/monitor-upsell-1.svg';
import monitorUpsellIcon2 from 'images/monitor-upsell-2.svg';
import React from 'react';
import { SonarCard } from '@ui/general';
import { SonarText } from '@ui/text';
import { useFeatureFlag } from '@hooks';

import { Button, Space } from 'antd';
import { COPY_SPECIFIC, URLS } from '@sonar-software/sonar-ts-constants';

export const MonitorUpsellCard: React.FC = () => {
	const hasEventMonitoring = useFeatureFlag(FeatureFlag.DataSecurityDashboard);

	if (hasEventMonitoring) {
		return null;
	}

	return (
		<SonarCard>
			<Space>
				<Space
					align='center'
					direction='vertical'
					style={ { gap: 16 } }>
					<SonarText className={ classNames('h2', 'upsell') }>
						{ COPY_SPECIFIC.REAL_TIME_ALERTS_UPSELL }
					</SonarText>
					<div className='upsell'>
						<p>
							<SonarText>{ COPY_SPECIFIC.REAL_TIME_ALERTS_UPSELL_LINE1 }</SonarText>
						</p>
						<p>
							<SonarText>{ COPY_SPECIFIC.REAL_TIME_ALERTS_UPSELL_LINE2 }</SonarText>
						</p>
						<p>
							<SonarText>{ COPY_SPECIFIC.REAL_TIME_ALERTS_UPSELL_LINE3 }</SonarText>
						</p>
					</div>
					<Button
						className='contact-us-button'
						href={ URLS.CUSTOMER_PACKAGE_UPGRADE }
						rel='noopener'
						target='_blank'
						type='primary'>
						{ COPY_SPECIFIC.CONTACT_US }
					</Button>
				</Space>
				<Icon
					component={ () => <img src={ monitorUpsellIcon1 } /> } />
				<Icon
					component={ () => <img src={ monitorUpsellIcon2 } /> } />
			</Space>
		</SonarCard>
	);
};
